import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import LazyLoading from './LazyLoading';

export default function BaseLayout() {
  return (
    <Box
      sx={{
        height: 'calc(var(--vh, 1vh) * 100)',
      }}>
      <LazyLoading>
        <Outlet />
      </LazyLoading>
    </Box>
  );
}
